import styled from 'styled-components';
import { ChevronRight } from 'react-feather';

import { colours } from 'themes/default';

export const StyledChevron = styled(ChevronRight)`
  color: ${colours.Core.CoreNavy};
`;

export const StyledAssistanceGroup = styled.div`
  padding: 10px 0px 0px 0px;
  margin-bottom: 25px;
  width: 100%;
`;

export const StyledAssistanceGroupHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledAssistanceToggle = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0;
  outline: none;
  font-weight: 600;
  color: ${(props) => (props.isActive ? colours.Core.CoreBlue : colours.Core.CoreNavy)};
  text-decoration: ${(props) => (props.isActive ? 'underline' : 'none')};
  padding-left: 0;
  cursor: pointer;

  svg {
    transform: translateX(10px) rotate(${(props) => (props.isActive ? '-90deg' : '90deg')});
  }
`;

export const StyledItems = styled.div`
  display: ${(props) => (props.visible ? 'block' : 'none')};
`;

export const StyledItem = styled.div`
  background-color: ${colours.Shades.TintBlue10};
  margin-left: 12px;
  margin-top: 16px;
  padding: 10px;
`;

export const StyledItemColumns = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 24px;
`;

export const StyledItemsContainer = styled.div`
  position: relative; /* to contain StyledRemoveButton */
`;

export const StyledRemoveButton = styled.button`
  border: none;
  background: transparent;
  text-decoration: underline;
  cursor: pointer;

  position: absolute;
  top: -27px;
  right: -5px; /* to align button to aqua bg (and keep padding) */

  color: ${colours.Core.CoreBlue};
`;

export const StyledAddAnotherPassenger = styled.button`
  border: none;
  background: transparent;
  text-decoration: underline;
  cursor: pointer;

  color: ${colours.Core.CoreBlue};
  margin-right: -5px; /* to align button to aqua bg (and keep padding) */

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const StyledStrong = styled.strong`
  display: block;
  margin-bottom: 10px;
`;

export const StyledItemColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;
export const StyledRadio = styled.input`
  margin-right: 5px;
`;

export const StyledRadioGroup = styled.div`
  @media (min-width: 924px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  height: 60px;
  resize: vertical;
  border-color: ${colours.Greyscale.SilverGrey};
  border-radius: 0.25rem;
  color: ${colours.Core.CoreNavy};

  &:focus {
    box-shadow: 0 0 0 1px ${colours.Shades.BlueShade40};
    outline: none;
  }
`;

export const StyledNumberInput = styled.input`
  width: 100%;
  border-color: ${colours.Greyscale.SilverGrey};
  border-radius: 0.25rem;
  color: ${colours.Core.CoreNavy};

  &:focus {
    box-shadow: 0 0 0 1px ${colours.Shades.BlueShade40};
    outline: none;
  }
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};
  padding-top: 5px;
  padding-bottom: 15px;
`;

export const StyledWarningMessage = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  color: ${(props) => (props.isAlerted ? colours.Messaging.ErrorRed : colours.Greyscale.CharcoalGrey)};
`;

export const StyledCommentWarning = styled.span`
  font-weight: normal;
  float: right;
`;
